// @ts-strict-ignore
import WithContainerRoute from 'mobile_web/modules/common/hocs/container-route'
import React, { FC } from 'react'
import { RouteComponentProps } from 'react-router'
import BadgesComponent from '../components/Badges'

const BadgesRoute: FC<RouteComponentProps> = props => <BadgesComponent {...props} />

export default WithContainerRoute(BadgesRoute)
